(function () {
  var routes = (window.theme && window.theme.routes) || { cart_add_url: '/cart/add', cart_url: '/cart' };

  function setCount(n) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = n; });
  }

  // Add to cart without leaving the page
  document.addEventListener('submit', function (e) {
    var form = e.target.closest ? e.target.closest('form[data-ajax-form]') : null;
    if (!form || !window.fetch) return;
    e.preventDefault();

    var btn = form.querySelector('[type="submit"]');
    var err = form.querySelector('[data-form-error]');
    var label = btn.getAttribute('data-label') || btn.textContent;
    if (err) { err.hidden = true; err.textContent = ''; }
    btn.disabled = true;
    btn.textContent = 'Adding…';

    fetch(routes.cart_add_url + '.js', {
      method: 'POST',
      body: new FormData(form),
      headers: { 'Accept': 'application/json' }
    })
      .then(function (res) { return res.json().then(function (data) { return { ok: res.ok, data: data }; }); })
      .then(function (r) {
        if (!r.ok) throw new Error(r.data.description || r.data.message || 'Could not add this item.');
        return fetch(routes.cart_url + '.js').then(function (res) { return res.json(); });
      })
      .then(function (cart) {
        setCount(cart.item_count);
        btn.textContent = 'Added';
        setTimeout(function () { btn.textContent = label; btn.disabled = false; }, 1600);
      })
      .catch(function (error) {
        btn.textContent = label;
        btn.disabled = false;
        if (err) { err.textContent = error.message; err.hidden = false; }
      });
  });

  // Update price when a variant is chosen
  document.addEventListener('change', function (e) {
    var sel = e.target.closest ? e.target.closest('[data-variant-select]') : null;
    if (!sel) return;
    var opt = sel.options[sel.selectedIndex];
    var box = document.querySelector('[data-product-price]');
    if (!box || !opt) return;
    var price = opt.getAttribute('data-price'), was = opt.getAttribute('data-compare');
    box.innerHTML = '';
    var p = document.createElement('span');
    p.className = 'price' + (was ? ' price--sale' : '');
    p.textContent = price;
    box.appendChild(p);
    if (was) {
      var s = document.createElement('s');
      s.className = 'price price--was';
      s.textContent = was;
      box.appendChild(s);
    }
  });

  // Back to top
  document.addEventListener('click', function (e) {
    var b = e.target.closest ? e.target.closest('[data-scroll-top]') : null;
    if (!b) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' });
  });

  // Infinite scroll
  function initInfinite(root) {
    if (!('IntersectionObserver' in window) || !window.fetch || root.getAttribute('data-ready')) return;
    root.setAttribute('data-ready', '1');
    var grid = root.querySelector('[data-infinite-grid]');
    var status = root.querySelector('[data-infinite-status]');
    var sentinel = root.querySelector('[data-infinite-sentinel]');
    var pager = root.querySelector('[data-infinite-pagination]');
    var next = root.getAttribute('data-next-url');
    var loading = false;
    if (pager) pager.hidden = true;
    if (!next) return;

    var io = new IntersectionObserver(function (entries) {
      if (entries[0].isIntersecting) load();
    }, { rootMargin: '800px 0px' });

    function fail() {
      io.disconnect();
      status.textContent = '';
      if (pager) pager.hidden = false;
    }

    function load() {
      if (loading || !next) return;
      loading = true;
      status.textContent = 'Loading more products…';
      fetch(next, { credentials: 'same-origin' })
        .then(function (res) { if (!res.ok) throw new Error('bad response'); return res.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var incoming = doc.getElementById(root.id);
          var items = incoming && incoming.querySelector('[data-infinite-grid]');
          if (!items) throw new Error('no grid');
          Array.prototype.forEach.call(items.children, function (card) {
            grid.appendChild(document.importNode(card, true));
          });
          next = incoming.getAttribute('data-next-url') || '';
          loading = false;
          status.textContent = '';
          if (next) { io.unobserve(sentinel); io.observe(sentinel); } else { io.disconnect(); }
        })
        .catch(function () { loading = false; fail(); });
    }
    io.observe(sentinel);
  }

  function initAllInfinite() {
    document.querySelectorAll('[data-infinite]').forEach(initInfinite);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAllInfinite);
  else initAllInfinite();
  document.addEventListener('shopify:section:load', initAllInfinite);
})();
